import CaseStatus from './CaseStatus';

export default CaseStatus;
